import React from 'react';
import type { WorkflowComponent } from '../../../types/workflow';
import type { EditableWorkflow } from '../../../utils/workflowDsl';
import WorkflowStateInspector from './WorkflowStateInspector';

export interface WorkflowStateConfiguratorViewProps {
  wf: EditableWorkflow;
  stateId: string;
  components: WorkflowComponent[];
  onPatch: (patch: Record<string, unknown>) => void;
  onRename: (newId: string) => void;
  onDelete: () => void;
  onSetEntry: () => void;
  onSelectEdge: (edgeId: string) => void;
  onSelectState: (stateId: string) => void;
  onBack: () => void;
}

/**
 * Clicking a state takes over the graph area with this screen — the same navigation the target
 * system's own admin uses, rather than a side panel or a dialog on top of the canvas. Everything
 * that used to live in the side "Inspector" (identity, prompts, agents, transitions, …) renders
 * here full-width; "To graph" is the only way back.
 */
const WorkflowStateConfiguratorView: React.FC<WorkflowStateConfiguratorViewProps> = ({
  wf,
  stateId,
  components,
  onPatch,
  onRename,
  onDelete,
  onSetEntry,
  onSelectEdge,
  onSelectState,
  onBack,
}) => {
  const state = wf.states[stateId];
  return (
    <div className="cwf-agents-view">
      <div className="cwf-agents-view__head">
        <button type="button" className="cwf-btn cwf-btn--sm" onClick={onBack}>
          <i className="fas fa-arrow-left" aria-hidden="true" /> To graph
        </button>
        <span className="cwf-agents-view__title">
          <i className="fas fa-sliders-h" aria-hidden="true" /> Configurator · {state?.state_name || <em>unnamed</em>}
        </span>
        <code className="cwf-agents-view__id">{stateId}</code>
      </div>
      <div className="cwf-agents-view__body">
        <WorkflowStateInspector
          wf={wf}
          stateId={stateId}
          components={components}
          onPatch={onPatch}
          onRename={onRename}
          onDelete={onDelete}
          onSetEntry={onSetEntry}
          onSelectEdge={onSelectEdge}
          onSelectState={onSelectState}
        />
      </div>
    </div>
  );
};

export default WorkflowStateConfiguratorView;
